import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

const BadgeStyles: { [key: string]: string } = {
	active: 'tw-text-green-600 tw-bg-green-50 tw-ring-green-600/20',
	info: 'tw-text-blue-700 tw-bg-blue-50 tw-ring-blue-700/10',
	warning: 'tw-text-orange-700 tw-bg-orange-50 tw-ring-orange-600/10',
	error: 'tw-text-red-700 tw-bg-red-50 tw-ring-red-600/10',
	pink: 'tw-text-pink-700 tw-bg-pink-50 tw-ring-pink-700/10',
	purple: 'tw-text-purple-700 tw-bg-purple-50 tw-ring-purple-700/10',
	indigo: 'tw-text-indigo-700 tw-bg-indigo-50 tw-ring-indigo-700/10',
	yellow: 'tw-text-yellow-600 tw-bg-yellow-50 tw-ring-yellow-600/20',
	gray: 'tw-text-gray-600 tw-bg-gray-50 tw-ring-gray-500/10',
	lime: 'tw-text-lime-700 tw-bg-lime-50 tw-ring-lime-700/20',
};

@Component({
	selector: 'mos-badge',
	templateUrl: './badge.component.html',
	imports: [NgClass],
	standalone: true,
})
export class BadgeComponent {
	@Input() public label: string;
	@Input() public type?: 'active' | 'info' | 'warning' | 'error' | 'gray' | 'yellow' | 'lime';

	protected readonly BadgeStyles = BadgeStyles;
}
